import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';
import { useAemConfig } from '@as-react/common-components';
import { generalQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { generateFieldName, isValidAddress } from '../addressFields.utils';
import { AddressFieldName, CountryId } from '@as-react/common-types';
import { mapWithAssert } from '../../../../util/ArrayUtil';
export const PostcodeHouseNumberWatcher = ({ prefix, countryId, postalCodeSearchFieldName, houseNumberSearchFieldName, onAddressFound, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [postalCodeFieldName, houseNumberFieldName, addressFieldName, cityFieldName, houseNumberAdditionFieldName] = mapWithAssert([
        AddressFieldName.POSTCODE,
        AddressFieldName.HOUSE_NUMBER,
        AddressFieldName.ADDRESS,
        AddressFieldName.CITY,
        AddressFieldName.HOUSE_NUMBER_ADDITION,
    ], name => generateFieldName(name, prefix));
    const { control, setError, setValue, clearErrors, trigger } = useFormContext();
    const [postalCode, houseNumber] = useWatch({
        control,
        name: [postalCodeSearchFieldName || postalCodeFieldName, houseNumberSearchFieldName || houseNumberFieldName],
    });
    const { getAddresses } = generalQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: addresses, error: addressError } = useQuery(getAddresses({ countryId, postalCode: postalCode, houseNumber: houseNumber }, {
        enabled: isValidAddress(postalCode, houseNumber, CountryId.NL),
        retry: false,
    }));
    useEffect(() => {
        if (addressError) {
            setError(postalCodeFieldName, { message: t('buy.error.no.results') });
            postalCodeSearchFieldName && setError(postalCodeSearchFieldName, { message: t('buy.error.no.results') });
        }
    }, [addressError]);
    useEffect(() => {
        if (!addresses || addresses.length === 0) {
            return;
        }
        const firstAddress = addresses[0];
        if (firstAddress.address) {
            setValue(addressFieldName, firstAddress.address, { shouldValidate: true });
            clearErrors(addressFieldName);
        }
        if (firstAddress.city) {
            setValue(cityFieldName, firstAddress.city);
            clearErrors(cityFieldName);
        }
        if (firstAddress.houseNumberAddition) {
            setValue(houseNumberAdditionFieldName, firstAddress.houseNumberAddition);
            clearErrors(houseNumberAdditionFieldName);
        }
        // set search post code and house number to the original fields
        postalCodeSearchFieldName && setValue(postalCodeFieldName, postalCode);
        houseNumberSearchFieldName && setValue(houseNumberFieldName, houseNumber);
        trigger([postalCodeFieldName, postalCodeSearchFieldName].filter(Boolean));
        onAddressFound === null || onAddressFound === void 0 ? void 0 : onAddressFound();
    }, [addresses]);
    return null;
};
